import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
	IRecurrenciesAttemptsResponse,
	IRecurrencyAttempt,
	IResponseRecurrencyAttempt,
} from 'app/interfaces/recurrent-attempts.interface';
import { environment } from 'environments/environment';
import { DateTime, Interval } from 'luxon';

import { UserService } from './../../services/user.service';

@Injectable({
	providedIn: 'root',
})
export class RecurrencyAttemptService {
	constructor(private http: HttpClient, private userService: UserService) {}

	hasReccurrencyAttemptOverlay(
		recurrencyAttempts: IRecurrencyAttempt[],
		slotInterval: Interval
	) {
		return recurrencyAttempts?.some((recurrency) => {
			return recurrency.interval.overlaps(slotInterval);
		});
	}

	getFormattedRecurrencyAttempts(
		recurrencyAttempts: IResponseRecurrencyAttempt[]
	): IRecurrencyAttempt[] {
		return recurrencyAttempts.map((recurrency) => {
			return {
				...recurrency,
				luxonDate: recurrency.luxonStartDate,
				interval: Interval.fromDateTimes(
					recurrency.luxonStartDate,
					recurrency.luxonEndDate
				),
				duration: recurrency.luxonEndDate.diff(
					recurrency.luxonStartDate,
					'minutes'
				).minutes,
			};
		});
	}

	getRecurrenciesAttempts(params: {
		startDate: string;
		endDate: string;
	}): Promise<IRecurrenciesAttemptsResponse> {
		const baseUrl = environment.servicesUrl;
		return this.http
			.get<IRecurrenciesAttemptsResponse>(
				`${baseUrl}/professional/professional/recurrent-schedules/attempts?startDate=${params.startDate}&endDate=${params.endDate}`
			)
			.toPromise()
			.then((response) => {
				response.data = response.data.map((recurrency) => {
					return {
						...recurrency,
						luxonStartDate: DateTime.fromISO(recurrency.startDate, {
							zone: this.userService.getTimezone(),
						}),
						luxonEndDate: DateTime.fromISO(recurrency.endDate, {
							zone: this.userService.getTimezone(),
						}),
					};
				});
				return response;
			})
			.catch(() => {
				return { data: [] };
			});
	}
}
